import { makeStyles } from '@material-ui/core'

const styles = (spacingXl, spacingLg, spacingMd, SpacingSm, SpacingXs) => {
  return makeStyles((theme) => ({
    container: {
      [theme.breakpoints.only('xl')]: {
        paddingLeft: theme.spacing(spacingXl),
        paddingRight: theme.spacing(spacingXl),
      },
      [theme.breakpoints.only('lg')]: {
        paddingLeft: theme.spacing(spacingLg),
        paddingRight: theme.spacing(spacingLg),
      },
      [theme.breakpoints.only('md')]: {
        paddingLeft: theme.spacing(spacingMd),
        paddingRight: theme.spacing(spacingMd),
      },
      [theme.breakpoints.only('sm')]: {
        paddingLeft: theme.spacing(SpacingSm),
        paddingRight: theme.spacing(SpacingSm),
      },
      [theme.breakpoints.only('xs')]: {
        paddingLeft: theme.spacing(SpacingXs),
        paddingRight: theme.spacing(SpacingXs),
      },
    },
  }))
}

export default styles
